"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getReCAPTCHAToken = require("../eos/getReCAPTCHAToken");
var _useDCS3Api = _interopRequireDefault(require("./useDCS3Api"));
const useUserService = function () {
  const v2Api = (0, _useDCS3Api.default)("V2");
  const v3Api = (0, _useDCS3Api.default)("V3");
  return {
    get: {
      user: function () {
        return v2Api.get("/customer");
      }
    },
    patch: {
      activateUser: function (payload) {
        return v2Api.patch("/admin/account/activation", payload);
      }
    },
    post: {
      address: async function (payload) {
        const token = await (0, _getReCAPTCHAToken.getReCAPTCHAToken)();
        const headers = {
          "X-DOMAIN-TOKEN": token
        };
        return v3Api.post("/customer/address", payload, headers);
      },
      forgotPassword: function (_ref) {
        let {
          email
        } = _ref;
        return v2Api.post(`/admin/customer/password/${email}`);
      },
      mfaCode: function (payload) {
        var _payload$useCase;
        return v2Api.post("/customer/mfa", {
          ...payload,
          useCase: (_payload$useCase = payload.useCase) !== null && _payload$useCase !== void 0 ? _payload$useCase : "change-profile"
        });
      },
      resendActivationEmail: function (_ref2) {
        let {
          email
        } = _ref2;
        return v2Api.post(`/admin/account/activation/email/${email}`);
      },
      user: function (payload) {
        return v2Api.post("/admin/customer", payload);
      }
    },
    put: {
      mfaUser: function (payload) {
        return v3Api.put("/customer", payload);
      },
      mfaPassword: function (payload) {
        return v3Api.put("/customer", payload);
      },
      password: function (payload) {
        return v2Api.put("/customer/password", payload);
      },
      phone: function (payload) {
        return v2Api.put("/customer/phone", payload);
      },
      resetPassword: function (payload) {
        return v2Api.put("/admin/customer/password/notUsed?idType=tmsGuid", payload);
      },
      user: function (payload) {
        return v2Api.put("/customer", payload);
      }
    }
  };
};
var _default = exports.default = useUserService;